/*@ngInject*/
const SendCollaborationEmailRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.sendCollaborationEmail = function (email) {
        let url = '/rest/Email/Send?submissionId=' + email.submissionId;

        return this.post(url, email);
    };
};

angular.module('gw-um-submission')
    .service('sendCollaborationEmailRepository', SendCollaborationEmailRepository);
